import React from "react";
import style from "../../style/Pages/Help/HomePageHelp.module.css"; // reuse the same styles
import { Link } from "react-router-dom";
import { IoHomeOutline } from "react-icons/io5";
import { TbArrowLeft } from "react-icons/tb";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const HomePanelHelp = () => {
  return (
    <>
      <SecondaryLayout>
        <div className={style.accountHelpWrapper}>
          <Link to="/help" className={style.backLink}>
            <TbArrowLeft className={style.backIcon} /> Back to Help Center
          </Link>

          <div className={style.header}>
            <IoHomeOutline className={style.headerIcon} />
            <h1>Home Panel</h1>
          </div>

          <div className={style.content}>
            <p>
              The <strong>Home Panel</strong> is your central hub for navigating
              and managing your entire chat environment. It brings together all
              your communication tools in one convenient place.
            </p>

            <h2>📺 Channels</h2>
            <ul>
              <li>
                Channels are topic-based conversation threads where teams can
                collaborate.
              </li>
              <li>
                You can join or leave public channels freely or be added to
                private ones by an admin.
              </li>
              <li>
                Each channel can have its own files, chat history, and pinned
                messages.
              </li>
            </ul>

            <h2>👥 Groups</h2>
            <ul>
              <li>
                Groups are collections of users for private discussions,
                projects, or departments.
              </li>
              <li>Only invited members can see and interact within a group.</li>
              <li>
                Useful for managing internal discussions or team-specific
                updates.
              </li>
            </ul>

            <h2>📨 Staff Chat</h2>
            <ul>
              <li>
                Staff chat allows internal team members or admins to communicate
                quickly.
              </li>
              <li>
                This space is typically used for management or system-wide
                announcements.
              </li>
              <li>
                Messages sent here can be seen by all staff across channels and
                groups (based on permissions).
              </li>
            </ul>

            <h2>📂 File Sharing & Mentions</h2>
            <ul>
              <li>
                All chats support file attachments like images, PDFs, and
                documents.
              </li>
              <li>
                Use <code>@mention</code> to tag someone and grab their
                attention directly.
              </li>
            </ul>

            <p>
              With the Home Panel, all your conversations — whether casual or
              critical — stay organized and easily accessible.
            </p>
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default HomePanelHelp;
